package navigation.home.suppliers.allsuppliers

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.supplier.domain.repository.SupplierRepository
import com.essntl.features.supplier.ui.allsuppliers.AllSuppliersEvent
import com.essntl.features.supplier.ui.allsuppliers.AllSuppliersState
import com.essntl.features.supplier.ui.allsuppliers.AllSuppliersViewModel

class AllSuppliersScreenModel(
    supplierRepository: SupplierRepository,
    categoryRepository: CategoryRepository,
    areaRepository: AreaRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<AllSuppliersState>(AllSuppliersState()) {
    private val allSuppliersViewModel =
        AllSuppliersViewModel(
            supplierRepository = supplierRepository,
            areaRepository = areaRepository,
            categoryRepository = categoryRepository,
            state = mutableState,
            scope = screenModelScope,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AllSuppliersEvent) {
        allSuppliersViewModel.onEvent(event)
    }
}
